<template>
<div class="chapter">
<div class="inner_page">
<p class="copy">Publisher: Amy Barrett-Daffin</p>
<p class="copy">Creative Director: Gailen Runge</p>
<p class="copy">Acquisitions Editor: Roxane Cerda</p>
<p class="copy">Managing Editor: Liz Aneloski</p>
<p class="copy">Editor: Katie Van Amburg</p>
<p class="copy">Technical Editor: Linda Johnson</p>
<p class="copy">Cover/Book Designer: April Mostek</p>
<p class="copy">Production Coordinator: Tim Manibusan</p>
<p class="copy">Production Editor: Alice Mace Nakanishi</p>
<p class="copy">Illustrators: Linda Johnson and Freesia Pearson Blizard</p>
<p class="copy">Photo Assistant: Gregory Ligman</p>
<p class="copy">Photography by Estefany Gonzalez of C&amp;T Publishing, Inc., unless otherwise noted</p>
<p class="copy">Published by C&amp;T Publishing, Inc., P.O. Box 1456, Lafayette, CA 94549</p>
<p class="figure-aligncenter-indent"><img alt="image" src="images/pg3_1.jpg"/></p>
<p class="figure-aligncenter-indent"><img alt="image" src="images/pg3_2.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_copyrighttitle.vue?c3fa7750